import { MatchEditPage } from "@/features/match/pages/MatchEdit";
import React from "react";

const MatchEdit = () => {
  return <MatchEditPage />;
};

export default MatchEdit;
